import { Crud } from "@/api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function dashboardLineItemEditLoader({
  params,
}: LoaderFunctionArgs) {
  const [lineItem] = await Promise.all([
    Crud.lineItems.get(params.lineItemId as string),
  ]);

  return { lineItem };
}
